import Navbar from "../../components/Navbar";
import Footer from "../home/components/Footer";
import { aboutData, processSteps, testimonials } from "../../mocks/homeData";
import { usePageMeta } from "../../hooks/usePageMeta";

export default function AboutPage() {
  usePageMeta({
    title: "Hakkimizda | Hangar Muhendislik",
    description:
      "2009'dan bu yana endustriyel yapi alaninda faaliyet gosteren Hangar Muhendislik'in yaklasimi, sureci ve referanslari.",
  });

  return (
    <div className="font-body antialiased">
      <Navbar />
      <main>
        {/* Hero Banner */}
        <section className="relative h-[420px] md:h-[520px] flex items-center justify-center overflow-hidden bg-navy">
          <div className="absolute inset-0 opacity-20">
            <img
              src="https://storage.readdy-site.link/project_files/ca0597d3-e4ee-4889-8ae5-f7591fdfc85d/58ab5f28-3592-40c8-b5e9-8eb9636f3001_img-2.jpeg?v=1086701f389696e02e2d9a68d4339d33"
              alt="Hakkımızda Arkaplan"
              className="w-full h-full object-cover"
            />
          </div>
          <div className="absolute inset-0 bg-gradient-to-b from-navy/70 via-navy/50 to-navy/70" />
          <div className="relative max-w-[1400px] mx-auto px-4 md:px-6 lg:px-8 text-center">
            <div className="inline-block w-12 h-1 rounded-full bg-copper mb-6" />
            <h1 className="font-heading font-bold text-3xl md:text-4xl lg:text-5xl text-white mb-4">
              Hakkımızda
            </h1>
            <p className="font-body text-base md:text-lg text-white/70 max-w-2xl mx-auto">
              2009'dan bu yana endüstriyel yapı sektöründe güvenilir çözüm ortağınız.
            </p>
          </div>
        </section>

        {/* About Content */}
        <section className="bg-white py-16 md:py-24 lg:py-32 overflow-hidden">
          <div className="max-w-[1400px] mx-auto px-4 md:px-6 lg:px-8">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 md:gap-16 items-center mb-20 md:mb-28">
              <div className="relative">
                <div className="relative rounded-lg overflow-hidden">
                  <img
                    src={aboutData.image}
                    alt="Hangar Mühendislik Üretim Tesisi"
                    className="w-full h-[400px] md:h-[500px] object-cover object-top"
                  />
                  <div className="absolute inset-0 bg-gradient-to-r from-navy/20 to-transparent" />
                </div>
                <div className="absolute -bottom-6 -right-2 md:-right-6 bg-white rounded-lg shadow-lg border border-gray-100 p-4 md:p-6">
                  <div className="font-heading font-extrabold text-3xl md:text-4xl text-copper">{aboutData.sinceYear}</div>
                  <div className="font-body text-sm text-gray-600 mt-1">Kuruluş Yılı</div>
                </div>
              </div>
              <div>
                <div className="inline-block w-12 h-1 rounded-full bg-copper mb-4" />
                <h2 className="font-heading font-bold text-2xl md:text-3xl lg:text-4xl text-navy mb-4 md:mb-6">
                  {aboutData.title}
                </h2>
                <p className="font-body text-base md:text-lg text-gray-600 leading-relaxed mb-4">
                  {aboutData.description}
                </p>
                <p className="font-body text-base text-gray-600 leading-relaxed mb-6 md:mb-8">
                  {aboutData.description2}
                </p>
                <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 md:gap-6">
                  {aboutData.values.map((value) => (
                    <div
                      key={value.title}
                      className="p-4 md:p-5 rounded-lg bg-gray-50 border border-gray-100 hover:border-copper/30 transition-colors"
                    >
                      <div className="w-10 h-10 flex items-center justify-center rounded-md bg-copper/10 text-copper mb-3">
                        <i className={`${value.icon} text-xl`} />
                      </div>
                      <h4 className="font-heading font-semibold text-sm md:text-base text-navy mb-1">
                        {value.title}
                      </h4>
                      <p className="font-body text-xs md:text-sm text-gray-600 leading-relaxed">
                        {value.description}
                      </p>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Process */}
        <section className="bg-gray-50 py-16 md:py-24 lg:py-32">
          <div className="max-w-[1400px] mx-auto px-4 md:px-6 lg:px-8">
            <div className="text-center mb-12 md:mb-16">
              <div className="inline-block w-12 h-1 rounded-full bg-copper mb-4" />
              <h2 className="font-heading font-bold text-2xl md:text-3xl lg:text-4xl text-navy mb-4">
                Çalışma Sürecimiz
              </h2>
              <p className="font-body text-base md:text-lg text-gray-600 max-w-2xl mx-auto">
                5 adımlık sistematik sürecimizle projelerinizi zamanında ve bütçe dahilinde teslim ediyoruz.
              </p>
            </div>
            <div className="relative">
              <div className="hidden lg:block absolute top-[60px] left-[10%] right-[10%] h-0.5 bg-gray-300" />
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-8 md:gap-6">
                {processSteps.map((step) => (
                  <div key={step.step} className="relative flex flex-col items-center text-center">
                    <div className="relative mb-4 md:mb-5">
                      <div className="w-16 h-16 md:w-20 md:h-20 rounded-full bg-white border-[3px] border-copper flex items-center justify-center shadow-md z-10 relative">
                        <div className="w-8 h-8 md:w-10 md:h-10 flex items-center justify-center text-copper">
                          <i className={`${step.icon} text-2xl md:text-3xl`} />
                        </div>
                      </div>
                      <div className="absolute -top-2 -right-2 w-7 h-7 md:w-8 md:h-8 rounded-full bg-copper text-white font-heading font-bold text-xs md:text-sm flex items-center justify-center">
                        {step.step}
                      </div>
                    </div>
                    <h3 className="font-heading font-bold text-base md:text-lg text-navy mb-2">{step.title}</h3>
                    <p className="font-body text-sm text-gray-600 leading-relaxed">{step.description}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>

        {/* Stats */}
        <section className="bg-navy py-16 md:py-20">
          <div className="max-w-[1400px] mx-auto px-4 md:px-6 lg:px-8">
            <div className="grid grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8 text-center">
              <div>
                <div className="font-heading font-extrabold text-3xl md:text-4xl text-copper mb-2">250+</div>
                <div className="font-body text-sm text-white/70">Tamamlanan Proje</div>
              </div>
              <div>
                <div className="font-heading font-extrabold text-3xl md:text-4xl text-copper mb-2">150+</div>
                <div className="font-body text-sm text-white/70">Mutlu Müşteri</div>
              </div>
              <div>
                <div className="font-heading font-extrabold text-3xl md:text-4xl text-copper mb-2">20+</div>
                <div className="font-body text-sm text-white/70">Uzman Ekip</div>
              </div>
              <div>
                <div className="font-heading font-extrabold text-3xl md:text-4xl text-copper mb-2">15+</div>
                <div className="font-body text-sm text-white/70">Yıllık Deneyim</div>
              </div>
            </div>
          </div>
        </section>

        {/* Testimonials */}
        <section className="bg-white py-16 md:py-24 lg:py-32">
          <div className="max-w-[1400px] mx-auto px-4 md:px-6 lg:px-8">
            <div className="text-center mb-12 md:mb-16">
              <div className="inline-block w-12 h-1 rounded-full bg-copper mb-4" />
              <h2 className="font-heading font-bold text-2xl md:text-3xl lg:text-4xl text-navy mb-4">
                Müşterilerimiz Ne Diyor?
              </h2>
              <p className="font-body text-base md:text-lg text-gray-600 max-w-2xl mx-auto">
                Gerçek müşteri deneyimleri ve projeler hakkında değerlendirmeler.
              </p>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
              {testimonials.map((t) => (
                <div key={t.id} className="bg-gray-50 rounded-lg p-6 md:p-8 border border-gray-100 hover:border-copper/20 transition-colors">
                  <div className="flex items-center gap-3 mb-4">
                    <img src={t.logo} alt={t.company} className="w-10 h-10 rounded-full object-cover" />
                    <div>
                      <h4 className="font-heading font-semibold text-sm text-navy">{t.company}</h4>
                      <p className="font-body text-xs text-gray-500">{t.author} — {t.role}</p>
                    </div>
                  </div>
                  <p className="font-body text-sm text-gray-600 leading-relaxed italic">&ldquo;{t.comment}&rdquo;</p>
                </div>
              ))}
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}
